import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createConnectedAccountActions } from './actions';
import { ConnectedAccountActions, ConnectedAccountState } from './types';

export const useConnectedAccountStore = create<ConnectedAccountState & ConnectedAccountActions>()(
    immer((set, get, store) => ({
        connectedAccounts: [],
        loading: false,
        selectedConnectedAccount: null,
        loadingConnectedAccount: false,
        error: undefined,
        ...createConnectedAccountActions(set, get, store),
    })),
);
